export default __webpack_public_path__ + "static/media/quotation-2.0f130f25.svg";